import { getters } from '@/modules/core/app/helpers/store';
import { PublicPages } from '@/modules/core/app/constants/router.constants';
import SessionService from '@/modules/core/session/services/SessionService';
import { BaseRouteConfig } from '@/modules/core/app/helpers/BaseRouteConfig';
import { AppModule } from '@/modules/core/app/models/AppModule';

export class PageRouteConfig extends BaseRouteConfig {
  /**
   * @var {string}
   */
  moduleName;

  constructor(options, moduleName) {
    super(options);

    this.moduleName = moduleName;
  }

  /**
   * @param {Route} to
   * @param {Route} from
   * @param {function} next
   */
  beforeEnter(to, from, next) {
    if (this._isRouteProtected(to)) {
      try {
        this._canAccessRoute();
      } catch (e) {
        if (from && from.name) {
          return next(false);
        }
        next(SessionService.getLoginRedirectPath());
      }
    }
    next();
  }

  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    // @todo: pascal - store unique app paths and check if to.path is in that list - hence you have access since they are trimmed in the backend
    const appPermissionKeys = AppModule.getAppPermissionKeysForModule(this.moduleName);
    const permissionToReadModule = getters.session
      .getUserSettings()
      .hasPermissionToRead(this.moduleName);
    return appPermissionKeys
      ? permissionToReadModule &&
          getters.session.getUserSettings().hasAppPermissions(appPermissionKeys)
      : permissionToReadModule;
  }

  /**
   * @returns {boolean}
   * @protected
   */
  _canAccessRoute() {
    if (!this.canAccessRouteFromContext()) {
      throw new Error();
    }
  }

  /**
   * @returns {boolean}
   * @protected
   */
  _isRouteProtected(to) {
    return !PublicPages.includes(to.name);
  }
}
